const INIT_FLAG = 'stgbHoverVideoInit';

const initWrapper = (wrapper: HTMLElement) => {
    if (wrapper.dataset[INIT_FLAG] === 'true') return;

    const video = wrapper.querySelector<HTMLVideoElement>('video.stgb-hover-video');
    if (!video) return;

    const resetOnLeave = wrapper.dataset.stgbResetOnLeave === 'true';

    const play = () => {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') {
            promise.catch(() => { /* autoplay/network failures are non-fatal */ });
        }
    };

    const pause = () => {
        video.pause();
        if (resetOnLeave) {
            video.currentTime = 0;
        }
    };

    wrapper.addEventListener('mouseenter', play);
    wrapper.addEventListener('mouseleave', pause);
    wrapper.addEventListener('focusin', play);
    wrapper.addEventListener('focusout', pause);

    wrapper.dataset[INIT_FLAG] = 'true';
};

const initAll = () => {
    document
        .querySelectorAll<HTMLElement>('.stgb-hover-video-wrapper')
        .forEach(initWrapper);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}
